import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import LoadingSkeleton from 'marketing-platform-lib/components/LoadingSkeleton';
import { CAROUSEL_IMAGE_WIDTH } from 'framework-asset-preview-lib/internal/shared/constants/assetPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CarouselPreviewSkeleton() {
  return /*#__PURE__*/_jsxs(Flex, {
    inlineSize: `${CAROUSEL_IMAGE_WIDTH}px`,
    borderStyle: "solid",
    borderWidth: "100",
    borderColor: "border-core-subtle",
    padding: "400",
    borderRadius: "100",
    gap: "250",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: 0,
      shrink: 0,
      children: /*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "43px",
        inlineSize: "44px"
      })
    }), /*#__PURE__*/_jsxs(TFlex, {
      align: "stretch",
      direction: "column",
      gap: 10,
      children: [/*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "20px",
        inlineSize: "200px"
      }), /*#__PURE__*/_jsxs(TFlex, {
        gap: 10,
        children: [/*#__PURE__*/_jsx(LoadingSkeleton, {
          blockSize: "20px",
          inlineSize: "70px"
        }), /*#__PURE__*/_jsx(LoadingSkeleton, {
          blockSize: "20px",
          inlineSize: "40px"
        })]
      })]
    })]
  });
}